import { Box } from "@outschool/backpack";
import React from "react";

export function ClassDetails({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexGrow: 1,
        maxWidth: "100%",
        padding: "10px 12px",
        gap: "8px",
      }}
    >
      {children}
    </Box>
  );
}
